import React from "react";
import QuotationComponent from "../modals/QuoteLead";
// import { useRef } from "react";


const Quotations = () => {

  // const quotationRef = useRef()

  // const onCreateQuotation = () => {
  //   console.log('creat quotation clicked !!')
  //   quotationRef.current?.scrollIntoView({behavior:'smooth'})
  // }

  

  return (
    <div className="">
      <h3 className="px-4 text-xl font-normal text-gray-800">Quotation</h3>
      {/* <h3 ref={quotationRef} className="px-4 text-xl font-normal text-gray-800 mb-4">Quotations</h3> */}
     {/* create quotation for new lead */}
     <div >
      <QuotationComponent /> 
     </div>
       {/* <hr className="border-t w-full border-gray-700 my-8 "/> */}
      {/* <QuotationList onCreateQuotation={onCreateQuotation} /> */}
    </div>
  );
};

export default Quotations;
